export const APP_VERSION_URL = 'app-version';

export const FETCH_ONCE_SWR_OPTIONS = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
};
